import Energie from "../pages/energie/Energie";
import Zonneboiler from "../pages/energie/Zonneboiler";
import Zonnepanelen from "../pages/energie/Zonnepanelen";
import Bronnen from "../pages/ladage/Bronnen";
import Oorsprong from "../pages/ladage/Oorsprong";
import { StamreeksHuygens } from "../pages/ladage/StamreeksHuygens";
import { StamreeksLadage } from "../pages/ladage/StamreeksLadage";
import { StamreeksBekkers } from "../pages/ladage/StamreeksBekkers";
import Doortrappers from "../pages/lekkveld/Doortrappers";
import DoortrappersMuziek from "../pages/lekkveld/DoortrappersMuziek";
import Fotos from "../pages/lekkveld/Fotos";
import Videos from "../pages/lekkveld/Videos";
import Zomervakanties from "../pages/lekkveld/Zomervakanties";
import Na1900 from "../pages/neerbosch/Na1900";
import T1300E1375 from "../pages/neerbosch/T1300E1375";
import T1375E1450 from "../pages/neerbosch/T1375E1450";
import T1450E1750 from "../pages/neerbosch/T1450E1750";
import T1750E1900 from "../pages/neerbosch/T1750E1900";
import Voor1300 from "../pages/neerbosch/Voor1300";
import DeBedriegers from "../pages/spellen/DeBedriegers";
import Hunted from "../pages/spellen/Hunted";
import Titania from "../pages/spellen/Titania";
import WieIsDeMolOnline from "../pages/spellen/WieIsDMolOnline";
import SubMenu from "./SubMenu";
import Carpethia from "../pages/d&d/Capethia";
import DeOrdeVanHetVliegendeZwaard from "../pages/d&d/DeOrde";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
export type Menu = MenuItem[];

export type MenuOptions = {
  name: string;
  url: string;
  component?: () => JSX.Element;
  submenu?: MenuItem[];
};

export type MenuItem = MenuOptions & {
  component: () => JSX.Element;
};

export const lekkveldMenu: MenuItem = createMenu({
  name: "Lekkveld",
  url: "/lekkveld",
  submenu: [
    {
      name: "Zomervakanties",
      url: "/zomervakanties",
      component: Zomervakanties,
    },
    {
      name: "Doortrappers",
      url: "/doortrappers",
      component: Doortrappers,
    },
    {
      name: "Doortrappers Muziek",
      url: "/doortrappersmuziek",
      component: DoortrappersMuziek,
    },
    {
      name: "Foto's",
      url: "/fotos",
      component: Fotos,
    },
    {
      name: "Video's",
      url: "/videos",
      component: Videos,
    },
  ],
});

const stamreeksLadageComponent = <StamreeksLadage />;
const stamreeksHuygensComponent = <StamreeksHuygens />;
const stamreeksBekkersComponent = <StamreeksBekkers />;
export const ladageMenu: MenuItem = createMenu({
  name: "Stamboom",
  url: "/stamboom",
  submenu: [
    {
      name: "Oorsprong",
      url: "/oorsprong",
      component: Oorsprong,
    },
    {
      name: "Stamreeks Ladage",
      url: "/stamreeksladage",
      component: () => stamreeksLadageComponent,
    },
    {
      name: "Stamreeks Huygens",
      url: "/stamreekshuygens",
      component: () => stamreeksHuygensComponent,
    },
    {
      name: "Stamreeks Bekkers",
      url: "/stamreeksbekkers",
      component: () => stamreeksBekkersComponent,
    },
    {
      name: "Bronnen",
      url: "/bronnen",
      component: Bronnen,
    },
  ],
});

const energieMenu: MenuItem = createMenu({
  name: "Energie",
  url: "/energie",
  submenu: [
    {
      name: "Home",
      url: "/home",
      component: Energie,
    },
    {
      name: "Zonnepanelen",
      url: "/zonnepanelen",
      component: Zonnepanelen,
    },
    {
      name: "Zonneboiler",
      url: "/zonneboiler",
      component: Zonneboiler,
    },
  ],
});

const spellenMenu: MenuItem = createMenu({
  name: "Spellen",
  url: "/spellen",
  submenu: [
    {
      name: "Titania",
      url: "/titania",
      component: Titania,
    },
    {
      name: "Wie is de Mol Online",
      url: "/wieisdemolonline",
      component: WieIsDeMolOnline,
    },
    {
      name: "De Bedriegers",
      url: "/debedriegers",
      component: DeBedriegers,
    },
    {
      name: "Hunted4Kids",
      url: "/hunted",
      component: Hunted,
    },
  ],
});

const neerboschMenu: MenuItem = createMenu({
  name: "Neerbosch",
  url: "/neerbosch",
  submenu: [
    {
      name: "Voor 1300",
      url: "/voor1300",
      component: Voor1300,
    },
    {
      name: "1300-1375",
      url: "/tussen1300en1375",
      component: T1300E1375,
    },
    {
      name: "1375-1450",
      url: "/tussen1375en1450",
      component: T1375E1450,
    },
    {
      name: "1450-1750",
      url: "/tussen1450en1750",
      component: T1450E1750,
    },
    {
      name: "1750-1900",
      url: "/tussen1750en1900",
      component: T1750E1900,
    },
    {
      name: "Na 1900",
      url: "/na1900",
      component: Na1900,
    },
  ],
});

const dndMenu: MenuItem = createMenu({
  name: "D&D",
  url: "/dnd",
  submenu: [
    {
      name: "Carpéthia",
      url: "/carpethia",
      component: Carpethia,
    },
    {
      name: "Orde van het Vliegende Zwaard",
      url: "/deorde",
      component: DeOrdeVanHetVliegendeZwaard,
    },
  ],
});

export const mainMenuItems: Menu = [lekkveldMenu, ladageMenu, energieMenu, spellenMenu, dndMenu, neerboschMenu];

function createMenu(options: MenuOptions): MenuItem {
  const menuItem = options;
  menuItem.component = () => {
    return <SubMenu menuItem={options} />;
  };
  return menuItem as MenuItem;
}
